<template>
    <div>
        <b-nav tabs>
            <b-nav-item router-link to="dashboard-overview">
                <icon name="chart-area"></icon> ภาพรวม
            </b-nav-item>&nbsp;
            <b-nav-item router-link to="dashboard-selling">
                <icon name="chart-area"></icon> ภาพรวมการขาย
            </b-nav-item>
        </b-nav>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "dashboard-layout",
        data() {
            return {

            }
        },
    }
</script>

<style scoped>

</style>
